module.exports = __webpack_public_path__ + "images/dashboard-operation-logs-a3bab5e85ec44dc4cd1ca29e554aa463.png";